import {
    Dealer_Details,
    Attendences,
    Activity_Details,
    IsUserCheckout,
    Dealer_Activity_Types,
    NEW_ACTIVITY,
    GET_DEALER_BY_ID,
    RESCHEDULE_ACTIVITY,
    GET_SENIOR,
    APPROVE_AND_REJECT,
    TAGGED_ALONG_LIST,
    TAGGED_ALONG_BY_ID,
    ADD_TAGGED_ALONG,
    ACTIVITY_FILTER,
    MEETING_RATING,
    HEALTH_CARD,
    DEALER_PROFILE_DATA,
    GET_JUNIOR_LISTING_FOR_HOD,
    GET_SELF_LISTING,
    SAVE_RATING_FOR_HOD,
    SM_DETAILS_BY_USER_ID,
    RM_VIEW_DETAILS,
    STAR_CHECK,
    EMAIL_DROPDOWN,
    VERIFY_UCD_DEALER,
    UCD_DEALER_BY_ID,
    UCD_DEALER_SAVE,
    OTP_GENERATION,
    UCD_LIST,
    FIRM_TYPE,
    UCD_DEALER_UPDATE,
    GET_DEALER_POC,
    UPDATE_DEALER_POC,
    CAR_BRAND,
    CAR_MODEL,
    CAR_VARIANT,
    BANK_LIST,
    ADD_CASE,
    CASES_BY_LSQ_DEALER_ID,
    CASES_STATUS_UPDATE,
    CASE_LIST,
    CASE_BY_ID,
    LOAN_APPLICATION_BY_ID,
    LOAN_APPLICATION_UPDATE,
    PAYMENT_RAISE,
    LOAN_ACCOUNTS,
    LOAN_UNDERTAKING,
    APPROVAL_REQUEST,
    LOAN_TRANCHES,
    PAYMENT_RAISE_UPDATE,
    PAYOUT_DETAILS_UPDATE,
    GET_PAYOUT_DETAILS,
    NEW_BANK_DETAILS,
    UPDATE_TRANCHE_STATUS,
    FORE_CLOSURE_ACCOUNT,
    VEHICLE_DETAILS,
    AGREEMENT_UCD_NOTIFICATION,
    AGREEMENT_UCD_VERIFIED,
    DEALER_APPROVED_LIST,
    RC_CASE_BY_ID
} from "./type";
import {checkAgreementVerifiedRequest, ucdAgreementNotificationRequest} from "./action";

const initialState = {
    getDealerDetails: [],
    markAttendance:[],
    getActivity:[],
    isCheckoutDetails:[],
    activityTypesDetails:[],
    saveNewActivity:[],
    dealerById:[],
    rescheduleActivity: [],
    senior:[],
    taggedApproveAndReject:[],
    taggedList:[],
    taggedById:[],
    addedTaggedAlong:[],
    activityFilter:[],
    savedRating:[],
    getProfileData: [],
    healthCardRes: [],
    juniorListHod: [],
    selfListing:[],
    ratingByHod:[],
    getStarCheck:[],
    getSmDetails: [],
    getRmDetails: [],
    getEmailDropdown: [],
    verifiedUCD: [],
    ucdDetails: [],
    ucsSaveResponse: [],
    otp: [],
    ucdList: [],
    firms: [],
    ucdUpdate: [],
    getPocDetails: [],
    updateDealerPocDetails: [],
    carBrandResponse: [],
    carModelResponse: [],
    carVariantResponse: [],
    bankListResponse: [],
    caseByLsqDealerIdResponse: [],
    caseStatusUpdateResponse: [],
    addCaseResponse: [],
    caseListResponse: [],
    caseByIdResponse: [],
    loanApplicationByIdResponse: [],
    loanApplicationUpdateResponse: [],
    loanPaymentRaiseResponse: [],
    loanAccountResponse: [],
    loanUndertakingResponse: [],
    loanApprovalRequestResponse: [],
    loanTranchesResponse: [],
    loanPaymentRaiseUpdateResponse: [],
    updatePayoutDetails: [],
    getPayoutDetailsUsingLoanId: [],
    newBankDetailsResponse: [],
    updateTrancheStatusResponse: [],
    foreClosureAddAccountResponse: [],
    vehicleDetailsResponse: [],
    ucdAgreementNotificationResponse: [],
    checkAgreementVerifiedResponse: [],
    fetchDealerApprovalResponse: [],
    rcCaseByIdResponse: []
};

const Dealer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case Dealer_Details:
            return {
                ...state,
                getDealerDetails: payload,
            };
        case Attendences:
            return {
                ...state,
                markAttendance: payload,
            };
        case Activity_Details:
            return {
                ...state,
                getActivity: payload,
            };
        case IsUserCheckout:
            return {
                ...state,
                isCheckoutDetails: payload,
            };
        case Dealer_Activity_Types:
            return {
                ...state,
                activityTypesDetails: payload,
            };
        case NEW_ACTIVITY:
            return {
                ...state,
                saveNewActivity: payload,
            };
        case GET_DEALER_BY_ID:
            return {
                ...state,
                dealerById: payload,
            };
        case RESCHEDULE_ACTIVITY:
            return {
                ...state,
                rescheduleActivity: payload,
            };
        case GET_SENIOR:
            return {
                ...state,
                senior: payload,
            };
        case APPROVE_AND_REJECT:
            return {
                ...state,
                taggedApproveAndReject: payload,
            };
        case TAGGED_ALONG_LIST:
            return {
                ...state,
                taggedList: payload,
            };
        case TAGGED_ALONG_BY_ID:
            return {
                ...state,
                taggedById: payload,
            };
        case ADD_TAGGED_ALONG:
            return {
                ...state,
                addedTaggedAlong: payload,
            };
        case ACTIVITY_FILTER:
            return {
                ...state,
                activityFilter: payload,
            };
        case MEETING_RATING:
            return {
                ...state,
                savedRating: payload,
            };
        case HEALTH_CARD:
            return {
                ...state,
                healthCardRes: payload,
            };
        case GET_JUNIOR_LISTING_FOR_HOD:
            return {
                ...state,
                juniorListHod: payload,
            };
        case GET_SELF_LISTING:
            return {
                ...state,
                selfListing: payload,
            };
        case SAVE_RATING_FOR_HOD:
            return {
                ...state,
                ratingByHod: payload,
            };
        case STAR_CHECK:
            return {
                ...state,
                getStarCheck: payload,
            };
        case EMAIL_DROPDOWN:
            return {
                ...state,
                getEmailDropdown: payload,
            };
        case SM_DETAILS_BY_USER_ID:
            return {
                ...state,
                getSmDetails: payload,
            };
        case RM_VIEW_DETAILS:
            return {
                ...state,
                getRmDetails: payload,
            };
        case DEALER_PROFILE_DATA:
            return {
                ...state,
                getProfileData: payload,
            };
        case VERIFY_UCD_DEALER:
            return {
                ...state,
                verifiedUCD: payload,
            };
        case UCD_DEALER_BY_ID:
            return {
                ...state,
                ucdDetails: payload,
            };
        case UCD_DEALER_SAVE:
            return {
                ...state,
                ucsSaveResponse: payload,
            };
        case OTP_GENERATION:
            return {
                ...state,
                otp: payload,
            };
        case UCD_LIST:
            return {
                ...state,
                ucdList: payload,
            };
        case FIRM_TYPE:
            return {
                ...state,
                firm: payload,
            };
        case UCD_DEALER_UPDATE:
            return {
                ...state,
                ucdUpdate: payload,
            };
        case GET_DEALER_POC:
            return {
                ...state,
                getPocDetails: payload,
            };
        case UPDATE_DEALER_POC:
            return {
                ...state,
                updatePocDetails: payload,
            };
        case CAR_BRAND:
            return {
                ...state,
                carBrandResponse: payload,
            };
        case CAR_MODEL:
            return {
                ...state,
                carModelResponse: payload,
            };
        case CAR_VARIANT:
            return {
                ...state,
                carVariantResponse: payload,
            };
        case BANK_LIST:
            return {
                ...state,
                bankListResponse: payload,
            };
        case ADD_CASE:
            return {
                ...state,
                addCaseResponse: payload,
            };
        case CASES_BY_LSQ_DEALER_ID:
            return {
                ...state,
                caseByLsqDealerIdResponse: payload,
            };
        case CASES_STATUS_UPDATE:
            return {
                ...state,
                caseStatusUpdateResponse: payload,
            };
        case CASE_LIST:
            return {
                ...state,
                caseListResponse: payload,
            };
        case CASE_BY_ID:
            return {
                ...state,
                caseByIdResponse: payload,
            };
        case LOAN_APPLICATION_BY_ID:
            return {
                ...state,
                loanApplicationByIdResponse: payload,
            };
        case LOAN_APPLICATION_UPDATE:
            return {
                ...state,
                loanApplicationUpdateResponse: payload,
            };
        case PAYMENT_RAISE:
            return {
                ...state,
                loanPaymentRaiseResponse: payload,
            };
        case LOAN_ACCOUNTS:
            return {
                ...state,
                loanAccountResponse: payload,
            };
        case LOAN_UNDERTAKING:
            return {
                ...state,
                loanUndertakingResponse: payload,
            };
        case APPROVAL_REQUEST:
            return {
                ...state,
                loanApprovalRequestResponse: payload,
            };
        case LOAN_TRANCHES:
            return {
                ...state,
                loanTranchesResponse: action.payload,
            };
        case PAYMENT_RAISE_UPDATE:
            return {
                ...state,
                loanPaymentRaiseUpdateResponse: action.payload,
            };
        case PAYOUT_DETAILS_UPDATE:
            return {
                ...state,
                updatePayoutDetails: action.payload,
            };
        case GET_PAYOUT_DETAILS:
            return {
                ...state,
                getPayoutDetailsUsingLoanId: action.payload,
            };
        case NEW_BANK_DETAILS:
            return {
                ...state,
                newBankDetailsResponse: action.payload,
            };
        case UPDATE_TRANCHE_STATUS:
            return {
                ...state,
                updateTrancheStatusResponse: action.payload,
            };
        case FORE_CLOSURE_ACCOUNT:
            return {
                ...state,
                foreClosureAddAccountResponse: action.payload,
            };
        case VEHICLE_DETAILS:
            return {
                ...state,
                vehicleDetailsResponse: action.payload,
            };
        case AGREEMENT_UCD_NOTIFICATION:
            return {
                ...state,
                ucdAgreementNotificationResponse: action.payload,
            };
        case AGREEMENT_UCD_VERIFIED:
            return {
                ...state,
                checkAgreementVerifiedResponse: action.payload,
            };
        case DEALER_APPROVED_LIST:
            return {
                ...state,
                fetchDealerApprovalResponse: action.payload,
            };
        case RC_CASE_BY_ID:
            return {
                ...state,
                rcCaseByIdResponse: action.payload,
            };
        default:
            return {...state};
    }
};

export default Dealer;